import _defineProperty from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _assertThisInitialized from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _toConsumableArray from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _inherits from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import React, { useState, useCallback, useRef, useEffect, useMemo, useImperativeHandle, forwardRef } from 'react'; //
// Required

var applyAnimatedValues;
var createStringInterpolator; //
// Optional
//

var now = function now() {
  return Date.now();
};

var colorNames = {};
var defaultElement;
var manualFrameloop;
var createAnimatedStyle;
var createAnimatedTransform;
var createAnimatedInterpolation;

var createAnimatedRef = function createAnimatedRef(node) {
  return node.current;
};

var requestAnimationFrame = typeof window !== 'undefined' ? window.requestAnimationFrame : function () {};
var cancelAnimationFrame = typeof window !== 'undefined' ? window.cancelAnimationFrame : function () {}; //
// Configuration
//

var assign = function assign(globals) {
  var _Object$assign = Object.assign({
    colorNames: colorNames,
    defaultElement: defaultElement,
    applyAnimatedValues: applyAnimatedValues,
    createStringInterpolator: createStringInterpolator,
    createAnimatedInterpolation: createAnimatedInterpolation,
    createAnimatedTransform: createAnimatedTransform,
    createAnimatedStyle: createAnimatedStyle,
    createAnimatedRef: createAnimatedRef,
    requestAnimationFrame: requestAnimationFrame,
    cancelAnimationFrame: cancelAnimationFrame,
    manualFrameloop: manualFrameloop
  }, globals);

  colorNames = _Object$assign.colorNames;
  defaultElement = _Object$assign.defaultElement;
  applyAnimatedValues = _Object$assign.applyAnimatedValues;
  createStringInterpolator = _Object$assign.createStringInterpolator;
  createAnimatedInterpolation = _Object$assign.createAnimatedInterpolation;
  createAnimatedTransform = _Object$assign.createAnimatedTransform;
  createAnimatedStyle = _Object$assign.createAnimatedStyle;
  createAnimatedRef = _Object$assign.createAnimatedRef;
  requestAnimationFrame = _Object$assign.requestAnimationFrame;
  cancelAnimationFrame = _Object$assign.cancelAnimationFrame;
  manualFrameloop = _Object$assign.manualFrameloop;
  return _Object$assign;
};

var Globals = /*#__PURE__*/Object.freeze({
  get applyAnimatedValues() {
    return applyAnimatedValues;
  },

  get createStringInterpolator() {
    return createStringInterpolator;
  },

  now: now,

  get colorNames() {
    return colorNames;
  },

  get defaultElement() {
    return defaultElement;
  },

  get manualFrameloop() {
    return manualFrameloop;
  },

  get createAnimatedStyle() {
    return createAnimatedStyle;
  },

  get createAnimatedTransform() {
    return createAnimatedTransform;
  },

  get createAnimatedInterpolation() {
    return createAnimatedInterpolation;
  },

  get createAnimatedRef() {
    return createAnimatedRef;
  },

  get requestAnimationFrame() {
    return requestAnimationFrame;
  },

  get cancelAnimationFrame() {
    return cancelAnimationFrame;
  },

  assign: assign
});

var Animated = /*#__PURE__*/function () {
  function Animated() {
    _classCallCheck(this, Animated);

    this.payload = void 0;
    this.children = [];
  }

  _createClass(Animated, [{
    key: "getAnimatedValue",
    value: function getAnimatedValue() {
      return this.getValue();
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return this.payload || this;
    }
  }, {
    key: "attach",
    value: function attach() {}
  }, {
    key: "detach",
    value: function detach() {}
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this.children;
    }
  }, {
    key: "addChild",
    value: function addChild(child) {
      if (this.children.length === 0) this.attach();
      this.children.push(child);
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      var index = this.children.indexOf(child);
      this.children.splice(index, 1);
      if (this.children.length === 0) this.detach();
    }
  }]);

  return Animated;
}();

var AnimatedArray = /*#__PURE__*/function (_Animated) {
  _inherits(AnimatedArray, _Animated);

  var _super = _createSuper(AnimatedArray);

  function AnimatedArray() {
    var _this2;

    _classCallCheck(this, AnimatedArray);

    _this2 = _super.apply(this, arguments);
    _this2.payload = void 0;
    return _this2;
  }

  _createClass(AnimatedArray, [{
    key: "attach",
    value: function attach() {
      var _this3 = this;

      this.payload.forEach(function (p) {
        return p instanceof Animated && p.addChild(_this3);
      });
    }
  }, {
    key: "detach",
    value: function detach() {
      var _this4 = this;

      this.payload.forEach(function (p) {
        return p instanceof Animated && p.removeChild(_this4);
      });
    }
  }]);

  return AnimatedArray;
}(Animated);

var AnimatedObject = /*#__PURE__*/function (_Animated2) {
  _inherits(AnimatedObject, _Animated2);

  var _super2 = _createSuper(AnimatedObject);

  function AnimatedObject(payload) {
    var _this5;

    _classCallCheck(this, AnimatedObject);

    _this5 = _super2.call(this);
    _this5.payload = payload;
    return _this5;
  }

  _createClass(AnimatedObject, [{
    key: "getValue",
    value: function getValue(animated) {
      if (animated === void 0) {
        animated = false;
      }

      var payload = {};

      for (var key in this.payload) {
        var value = this.payload[key];
        if (animated && !(value instanceof Animated)) continue;
        payload[key] = value instanceof Animated ? value[animated ? 'getAnimatedValue' : 'getValue']() : value;
      }

      return payload;
    }
  }, {
    key: "getAnimatedValue",
    value: function getAnimatedValue() {
      return this.getValue(true);
    }
  }, {
    key: "attach",
    value: function attach() {
      var _this6 = this;

      Object.values(this.payload).forEach(function (s) {
        return s instanceof Animated && s.addChild(_this6);
      });
    }
  }, {
    key: "detach",
    value: function detach() {
      var _this7 = this;

      Object.values(this.payload).forEach(function (s) {
        return s instanceof Animated && s.removeChild(_this7);
      });
    }
  }]);

  return AnimatedObject;
}(Animated);

var AnimatedStyle = /*#__PURE__*/function (_AnimatedObject) {
  _inherits(AnimatedStyle, _AnimatedObject);

  var _super3 = _createSuper(AnimatedStyle);

  function AnimatedStyle(style) {
    _classCallCheck(this, AnimatedStyle);

    if (style === void 0) {
      style = {};
    }

    return _super3.call(this, style.transform && createAnimatedTransform ? _extends({}, style, {
      transform: createAnimatedTransform(style.transform)
    }) : style);
  }

  return _createClass(AnimatedStyle);
}(AnimatedObject);

var is = {
  arr: Array.isArray,
  obj: function obj(a) {
    return Object.prototype.toString.call(a) === '[object Object]';
  },
  fun: function fun(a) {
    return typeof a === 'function';
  },
  str: function str(a) {
    return typeof a === 'string';
  },
  num: function num(a) {
    return typeof a === 'number';
  },
  und: function und(a) {
    return a === void 0;
  },
  boo: function boo(a) {
    return typeof a === 'boolean';
  }
};

function useForceUpdate() {
  var _useState = useState(false),
      f = _useState[1];

  var forceUpdate = useCallback(function () {
    return f(function (v) {
      return !v;
    });
  }, []);
  return forceUpdate;
}

function withDefault(value, defaultValue) {
  return value == null ? defaultValue : value;
}

function toArray(a) {
  return is.und(a) ? [] : Array.isArray(a) ? a : [a];
}

function callProp(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return is.fun(obj) ? obj.apply(void 0, args) : obj;
}

function getForwardProps(props) {
  var to = props.to,
      from = props.from,
      config = props.config,
      onStart = props.onStart,
      onRest = props.onRest,
      onFrame = props.onFrame,
      children = props.children,
      cancel = props.cancel,
      reset = props.reset,
      reverse = props.reverse,
      force = props.force,
      immediate = props.immediate,
      delay = props.delay,
      attach = props.attach,
      destroyed = props.destroyed,
      interpolateTo = props.interpolateTo,
      ref = props.ref,
      lazy = props.lazy,
      forward = _objectWithoutPropertiesLoose(props, ["to", "from", "config", "onStart", "onRest", "onFrame", "children", "cancel", "reset", "reverse", "force", "immediate", "delay", "attach", "destroyed", "interpolateTo", "ref", "lazy"]);

  return forward;
}

function interpolateTo(props) {
  var forward = getForwardProps(props);
  props = Object.entries(props).reduce(function (props, _ref) {
    var key = _ref[0],
        value = _ref[1];
    return key in forward || (props[key] = value), props;
  }, {});
  return _extends({
    to: forward
  }, props);
}

function handleRef(ref, forward) {
  if (forward) {
    // If it's a function, assume it's a ref callback
    if (is.fun(forward)) forward(ref);else if (is.obj(forward)) {
      forward.current = ref;
    }
  }

  return ref;
}
/** Use a value from the previous render */


function usePrev(value) {
  var prevRef = useRef(undefined);
  var prev = prevRef.current;
  prevRef.current = value;
  return prev;
}

function fillArray(length, mapIndex) {
  var arr = [];

  for (var i = 0; i < length; i++) {
    arr.push(mapIndex(i));
  }

  return arr;
}
/**
 * This tries to put deleted items back into the given `out` list in correct
 * order. Deleted items must have a `left` and `right` property with key of
 * their sibling which is used to find the correct placement.
 */


function reconcileDeleted(deleted, current) {
  // Copy as we will be mutating the arrays
  deleted = _toConsumableArray(deleted);
  current = _toConsumableArray(current); // Used to detect deadlock (when a pass finds 0 siblings)

  var failedTries = 0; // Track where the current pass start/ends

  var passIndex = 0;
  var nextPassIndex = deleted.length; // Insert all deleted items into `current`

  for (var i = 0; i < deleted.length; i++) {
    if (i === nextPassIndex) {
      // Sanity test: Push to end if somehow no siblings were found
      if (passIndex + failedTries === nextPassIndex) {
        for (var j = i; j < deleted.length; j++) {
          var _deleted$j = deleted[j],
              _left = _deleted$j.left,
              _right = _deleted$j.right,
              _deletedItem = _objectWithoutPropertiesLoose(_deleted$j, ["left", "right"]);

          current.push(_deletedItem);
        }

        break;
      } // Update local state at the end of each pass


      passIndex = nextPassIndex;
      nextPassIndex = deleted.length;
      failedTries = 0;
    } // The index of the deleted item in `current`


    var index = -1; // Look for the left or right sibling in `current`

    var _deleted$i = deleted[i],
        left = _deleted$i.left,
        right = _deleted$i.right,
        deletedItem = _objectWithoutPropertiesLoose(_deleted$i, ["left", "right"]);

    for (var _j = current.length; --_j >= 0;) {
      var key = current[_j].originalKey;

      if (key === right) {
        index = _j;
        break;
      }

      if (key === left) {
        index = _j + 1;
        break;
      }
    } // Items with no index are revisited in the next pass


    if (index < 0) {
      failedTries++;
      deleted.push(deleted[i]);
    } else {
      current.splice(index, 0, deletedItem);
    }
  }

  return current;
}

function freeze(obj) {
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
    return Object.freeze(obj);
  }

  return obj;
}

var AnimatedValueArray = /*#__PURE__*/function (_AnimatedArray) {
  _inherits(AnimatedValueArray, _AnimatedArray);

  var _super4 = _createSuper(AnimatedValueArray);

  function AnimatedValueArray(values) {
    var _this8;

    _classCallCheck(this, AnimatedValueArray);

    _this8 = _super4.call(this);
    _this8.payload = values;
    return _this8;
  }

  _createClass(AnimatedValueArray, [{
    key: "getValue",
    value: function getValue() {
      return this.payload.map(function (v) {
        return v.getValue();
      });
    }
  }, {
    key: "setValue",
    value: function setValue(value, flush) {
      var _this9 = this;

      if (flush === void 0) {
        flush = true;
      }

      if (is.arr(value)) {
        if (value.length === this.payload.length) {
          value.forEach(function (v, i) {
            return _this9.payload[i].setValue(v, flush);
          });
        }
      } else {
        this.payload.forEach(function (p) {
          return p.setValue(value, flush);
        });
      }
    }
  }, {
    key: "interpolate",
    value: function interpolate() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return createAnimatedInterpolation.apply(void 0, [this].concat(args));
    }
  }]);

  return AnimatedValueArray;
}(AnimatedArray);

var createInterpolator = function createInterpolator(range, output, extrapolate) {
  if (is.fun(range)) {
    return range;
  }

  if (is.arr(range)) {
    return createInterpolator({
      range: range,
      output: output,
      extrapolate: extrapolate
    });
  }

  if (is.str(range.output[0])) {
    return createStringInterpolator(range);
  }

  var config = range;
  var outputRange = config.output;
  var inputRange = config.range || [0, 1];
  var extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
  var extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';

  var easing = config.easing || function (t) {
    return t;
  };

  return function (input) {
    var range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
};

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  var result = map ? map(input) : input; // Extrapolate

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax; // Input Range

  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin); // Easing

  result = easing(result); // Output Range

  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) {
    if (inputRange[i] >= input) break;
  }

  return i - 1;
}
/** Wrap each element type of `T` with the `Animated` type */


var AnimatedInterpolation = /*#__PURE__*/function (_AnimatedArray2) {
  _inherits(AnimatedInterpolation, _AnimatedArray2);

  var _super5 = _createSuper(AnimatedInterpolation);

  function AnimatedInterpolation(parents, args) {
    var _this10;

    _classCallCheck(this, AnimatedInterpolation);

    _this10 = _super5.call(this);
    _this10.calc = void 0;
    _this10.calc = createInterpolator.apply(void 0, _toConsumableArray(args));
    _this10.payload = Array.isArray(parents) ? parents : parents instanceof AnimatedValueArray ? parents.getPayload() : [parents];
    return _this10;
  }

  _createClass(AnimatedInterpolation, [{
    key: "getValue",
    value: function getValue() {
      var args = this.payload.map(function (value) {
        return value.getValue();
      });
      return this.calc.apply(this, _toConsumableArray(args));
    }
  }, {
    key: "interpolate",
    value: function interpolate() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return createAnimatedInterpolation.apply(void 0, [this].concat(args));
    }
  }]);

  return AnimatedInterpolation;
}(AnimatedArray);
/** API
 *  useChain(references, timeSteps, timeFrame)
 */


function useChain(refs, timeSteps, timeFrame) {
  if (timeFrame === void 0) {
    timeFrame = 1000;
  }

  useEffect(function () {
    if (timeSteps) {
      var prevDelay = 0;
      refs.forEach(function (ref, i) {
        if (!ref.current) return;
        var controllers = ref.current.controllers;

        if (controllers.length) {
          var delay = timeFrame * timeSteps[i]; // Use the previous delay if none exists.

          if (isNaN(delay)) delay = prevDelay;else prevDelay = delay;
          controllers.forEach(function (ctrl) {
            ctrl.queue.forEach(function (props) {
              return props.delay += delay;
            });
            ctrl.start();
          });
        }
      });
    } else {
      var p = Promise.resolve();
      refs.forEach(function (ref) {
        var _ref = ref.current || {},
            controllers = _ref.controllers,
            start = _ref.start;

        if (controllers && controllers.length) {
          // Take the queue of each controller
          var updates = controllers.map(function (ctrl) {
            var q = ctrl.queue;
            ctrl.queue = [];
            return q;
          }); // Apply the queue when the previous ref stops animating

          p = p.then(function () {
            controllers.forEach(function (ctrl, i) {
              var _ctrl$queue;

              return (_ctrl$queue = ctrl.queue).push.apply(_ctrl$queue, _toConsumableArray(updates[i]));
            });
            return start();
          });
        } else {
          console.warn('useChain ref has no animations:', ref);
        }
      });
    }
  });
}

var active = false;
var controllers = new Set();

var update = function update() {
  if (!active) return false;
  var time = now();

  var _iterator = _createForOfIteratorHelper(controllers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var controller = _step.value;
      var isActive = false; // Number of updated animations

      var updateCount = 0;

      for (var configIdx = 0; configIdx < controller.configs.length; configIdx++) {
        var _config = controller.configs[configIdx];
        var endOfAnimation = void 0,
            lastTime = void 0;

        for (var valIdx = 0; valIdx < _config.animatedValues.length; valIdx++) {
          var animated = _config.animatedValues[valIdx];
          if (animated.done) continue;
          updateCount++;
          var to = _config.toValues[valIdx];
          var isAnimated = to instanceof Animated;
          if (isAnimated) to = to.getValue(); // Jump to end value for immediate animations

          if (_config.immediate) {
            animated.setValue(to);
            animated.done = true;
            continue;
          }

          var from = _config.fromValues[valIdx]; // Break animation when string values are involved

          if (typeof from === 'string' || typeof to === 'string') {
            animated.setValue(to);
            animated.done = true;
            continue;
          }

          var position = animated.lastPosition;
          var velocity = Array.isArray(_config.initialVelocity) ? _config.initialVelocity[valIdx] : _config.initialVelocity;

          if (_config.duration !== void 0) {
            /** Duration easing */
            position = from + _config.easing((time - animated.startTime) / _config.duration) * (to - from);
            endOfAnimation = time >= animated.startTime + _config.duration;
          } else if (_config.decay) {
            var decay = _config.decay === true ? 0.998 : _config.decay;
            /** Decay easing */

            position = from + velocity / (1 - decay) * (1 - Math.exp(-(1 - decay) * (time - animated.startTime)));
            endOfAnimation = Math.abs(animated.lastPosition - position) < 0.1;
            if (endOfAnimation) to = position;
          } else {
            /** Spring easing */
            lastTime = animated.lastTime !== void 0 ? animated.lastTime : time;
            velocity = animated.lastVelocity !== void 0 ? animated.lastVelocity : _config.initialVelocity; // If we lost a lot of frames just jump to the end.

            if (time > lastTime + 64) lastTime = time; // http://gafferongames.com/game-physics/fix-your-timestep/

            var numSteps = Math.floor(time - lastTime);

            for (var i = 0; i < numSteps; ++i) {
              var force = -_config.tension * (position - to);
              var damping = -_config.friction * velocity;
              var acceleration = (force + damping) / _config.mass;
              velocity = velocity + acceleration * 1 / 1000;
              position = position + velocity * 1 / 1000;
            } // Conditions for stopping the spring animation


            var isOvershooting = _config.clamp && _config.tension !== 0 ? from < to ? position > to : position < to : false;

            var isVelocity = Math.abs(velocity) <= _config.precision;

            var isDisplacement = _config.tension !== 0 ? Math.abs(to - position) <= _config.precision : true;
            endOfAnimation = isOvershooting || isVelocity && isDisplacement;
            animated.lastVelocity = velocity;
            animated.lastTime = time;
          } // Trails aren't done until their parents conclude


          if (isAnimated && !_config.toValues[valIdx].done) {
            endOfAnimation = false;
          }

          if (endOfAnimation) {
            // Ensure that we end up with a round value
            if (animated.value !== to) position = to;
            animated.done = true;
          } else {
            isActive = true;
          }

          animated.setValue(position);
          animated.lastPosition = position;
        } // Keep track of updated values only when necessary


        if (controller.props.onFrame) {
          controller.values[_config.key] = _config.animated.getValue();
        }
      }

      controller.onFrame(isActive, updateCount);
    } // Loop over as long as there are controllers ...

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (controllers.size) {
    if (manualFrameloop) manualFrameloop();else requestAnimationFrame(update);
  } else {
    active = false;
  }

  return active;
};

var start = function start(controller) {
  controllers.add(controller);

  if (!active) {
    active = true;
    if (manualFrameloop) manualFrameloop();else requestAnimationFrame(update);
  }
};

var stop = function stop(controller) {
  controllers.delete(controller);
};
/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an AnimatedValue is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */


function addAnimatedStyles(node, styles) {
  if ('update' in node) {
    styles.add(node);
  } else {
    node.getChildren().forEach(function (child) {
      return addAnimatedStyles(child, styles);
    });
  }
}

var AnimatedValue = /*#__PURE__*/function (_Animated3) {
  _inherits(AnimatedValue, _Animated3);

  var _super6 = _createSuper(AnimatedValue);

  function AnimatedValue(_value) {
    var _this11;

    _classCallCheck(this, AnimatedValue);

    var _this;

    _this11 = _super6.call(this);
    _this = _assertThisInitialized(_this11);
    _this11.animatedStyles = new Set();
    _this11.value = void 0;
    _this11.startPosition = void 0;
    _this11.lastPosition = void 0;
    _this11.lastVelocity = void 0;
    _this11.startTime = void 0;
    _this11.lastTime = void 0;
    _this11.done = false;

    _this11.setValue = function (value, flush) {
      if (flush === void 0) {
        flush = true;
      }

      _this.value = value;
      if (flush) _this.flush();
    };

    _this11.value = _value;

    if (is.num(_value)) {
      _this11.startPosition = _value;
      _this11.lastPosition = _value;
    }

    return _this11;
  }

  _createClass(AnimatedValue, [{
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "interpolate",
    value: function interpolate() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return createAnimatedInterpolation.apply(void 0, [this].concat(args));
    }
  }, {
    key: "reset",
    value: function reset(isActive) {
      if (is.num(this.value)) {
        this.startPosition = this.value;
        this.lastPosition = this.value;
        this.lastVelocity = isActive ? this.lastVelocity : undefined;
        this.lastTime = isActive ? this.lastTime : undefined;
        this.startTime = now();
      }

      this.done = false;
      this.animatedStyles.clear();
    }
  }, {
    key: "clearStyles",
    value: function clearStyles() {
      this.animatedStyles.clear();
    }
  }, {
    key: "flush",
    value: function flush() {
      if (this.animatedStyles.size === 0) {
        addAnimatedStyles(this, this.animatedStyles);
      }

      this.animatedStyles.forEach(function (animatedStyle) {
        return animatedStyle.update();
      });
    }
  }]);

  return AnimatedValue;
}(Animated); // Default easing


var linear = function linear(t) {
  return t;
};

var emptyObj = Object.freeze({});
var nextId = 1;

var Controller = /*#__PURE__*/function () {
  function Controller(props) {
    _classCallCheck(this, Controller);

    this.id = nextId++;
    this.idle = true;
    this.runCount = 0;
    this.destroyed = false;
    this.props = {};
    this.queue = [];
    this.timestamps = {};
    this.values = {};
    this.merged = {};
    this.animated = {};
    this.animations = {};
    this.configs = [];
    this.onEndQueue = [];
    this.cancelledAt = 0;
    if (props) this.update(props).start();
  }
  /**
   * Push props into the update queue. The props are used after `start` is
   * called and any delay is over. The props are intelligently diffed to ensure
   * that later calls to this method properly override any delayed props.
   * The `propsArg` argument is always copied before mutations are made.
   */


  _createClass(Controller, [{
    key: "update",
    value: function update(propsArg) {
      if (!propsArg || this.destroyed) return this;
      var props = interpolateTo(propsArg); // For async animations, the `from` prop must be defined for
      // the Animated nodes to exist before animations have started.

      this._ensureAnimated(props.from, true);

      this._ensureAnimated(props.to);

      props.timestamp = now(); // The `delay` prop of every update must be a number >= 0

      if (is.fun(props.delay) && is.obj(props.to)) {
        var from = props.from || emptyObj;

        for (var key in props.to) {
          this.queue.push(_extends({}, props, {
            to: _defineProperty({}, key, props.to[key]),
            from: key in from ? _defineProperty({}, key, from[key]) : void 0,
            delay: Math.max(0, Math.round(props.delay(key)))
          }));
        }
      } else {
        props.delay = is.num(props.delay) ? Math.max(0, Math.round(props.delay)) : 0; // Coerce falsy values to undefined for these props

        if (!props.to) props.to = void 0;
        if (!props.from) props.from = void 0;
        this.queue.push(props);
      }

      return this;
    }
    /**
     * Flush the update queue.
     * If the queue is empty, try starting the frameloop.
     */

  }, {
    key: "start",
    value: function start(onEnd) {
      if (this.queue.length) this._flush(onEnd);else this._start(onEnd);
      return this;
    }
    /** Stop one animation or all animations */

  }, {
    key: "stop",
    value: function stop() {
      var _this12 = this;

      for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
        keys[_key] = arguments[_key];
      }

      var finished = false;

      if (is.boo(keys[0])) {
        var _keys = keys;
        finished = _keys[0];
        keys = _keys.slice(1);
      } // Stop animations by key


      if (keys.length) {
        var _iterator2 = _createForOfIteratorHelper(keys),
            _step2;

        try {
          var _loop = function _loop() {
            var key = _step2.value;

            var index = _this12.configs.findIndex(function (config) {
              return key === config.key;
            });

            _this12._stopAnimation(key);

            _this12.configs[index] = _this12.animations[key];
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } // Stop all animations
      else if (this.runCount) {
        this.cancelledAt = now(); // Update the animation configs

        this.configs.forEach(function (config) {
          return _this12._stopAnimation(config.key);
        });
        this.configs = Object.values(this.animations); // Exit the frameloop

        this._stop(finished);
      }

      return this;
    }
    /** Revert the controller to its initial state */

  }, {
    key: "reset",
    value: function reset() {
      // Stop all current animations
      this.stop(); // Revert the internal state

      this.destroyed = false;
      this.props = {};
      this.queue = [];
      this.timestamps = {};
      this.values = {};
      this.merged = {};
      this.animated = {};
      this.animations = {};
      this.configs = [];
      return this;
    }
    /** Prevent all current and future animation */

  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.destroyed) {
        this.stop();
        this.destroyed = true;
      }
    }
    /** @internal Called by the frameloop */

  }, {
    key: "onFrame",
    value: function onFrame(isActive, updateCount) {
      if (updateCount) {
        var onFrame = this.props.onFrame;
        if (onFrame) onFrame(_extends({}, this.values));
      }

      if (!isActive) this._stop(true);
    }
    /**
     * Set a prop for the next animations where the prop is undefined. The given
     * value is overridden by the next update where the prop is defined.
     *
     * Ongoing animations are not changed.
     */

  }, {
    key: "setProp",
    value: function setProp(key, value) {
      this.props[key] = value;
      this.timestamps[key] = now();
      return this;
    } // Create an Animated node if none exists.

  }, {
    key: "_ensureAnimated",
    value: function _ensureAnimated(values, shouldUpdate) {
      if (shouldUpdate === void 0) {
        shouldUpdate = false;
      }

      if (!is.obj(values)) return;

      for (var key in values) {
        var value = values[key];
        var animated = this.animated[key];

        if (animated && shouldUpdate && this.animations[key].isNew) {
          // Ensure the initial value is up-to-date.
          if (animated.setValue) {
            animated.setValue(value);
          } else {
            // Derived nodes need to be swapped out.
            animated = null;
          }
        }

        if (!animated) {
          animated = createAnimated(value);

          if (animated) {
            if (this.animated[key]) {
              // Swap out the old node with the new node.
              moveChildren(this.animated[key], animated);
            }

            this.animated[key] = animated;

            this._stopAnimation(key, true);
          } else {
            console.warn('Given value not animatable:', value);
          }
        }
      }
    } // Listen for all animations to end.

  }, {
    key: "_onEnd",
    value: function _onEnd(onEnd) {
      if (this.runCount) this.onEndQueue.push(onEnd);else onEnd(true);
    } // Add this controller to the frameloop.

  }, {
    key: "_start",
    value: function _start(onEnd) {
      if (onEnd) this._onEnd(onEnd);

      if (this.idle && this.runCount) {
        this.idle = false;
        start(this);
      }
    } // Remove this controller from the frameloop, and notify any listeners.

  }, {
    key: "_stop",
    value: function _stop(finished) {
      this.idle = true;
      stop(this);
      var onEndQueue = this.onEndQueue;

      if (onEndQueue.length) {
        this.onEndQueue = [];
        onEndQueue.forEach(function (onEnd) {
          return onEnd(finished);
        });
      }
    } // Execute the current queue of prop updates.

  }, {
    key: "_flush",
    value: function _flush(onEnd) {
      var _this13 = this;

      var queue = this.queue.reduce(reduceDelays, []);
      this.queue.length = 0; // Track the number of active `_run` calls.

      var runsLeft = Object.keys(queue).length;
      this.runCount += runsLeft; // Never assume that the last update always finishes last, since that's
      // not true when 2+ async updates have indeterminate durations.

      var onRunEnd = function onRunEnd(finished) {
        _this13.runCount--;
        if (--runsLeft) return;
        if (onEnd) onEnd(finished);

        if (!_this13.runCount && finished) {
          var onRest = _this13.props.onRest;
          if (onRest) onRest(_this13.merged);
        }
      };

      queue.forEach(function (props, delay) {
        if (delay) {
          setTimeout(function () {
            // Cancelling methods touch the `cancelledAt` property
            if (props.timestamp < _this13.cancelledAt) return;

            _this13._run(props, onRunEnd);
          }, delay);
        } else {
          _this13._run(props, onRunEnd);
        }
      });
    } // Update the props and animations

  }, {
    key: "_run",
    value: function _run(props, onEnd) {
      if (is.arr(props.to) || is.fun(props.to)) {
        this._runAsync(props, onEnd);
      } else if (this._diff(props)) {
        this._animate(props)._start(onEnd);
      } else {
        this._onEnd(onEnd);
      }
    } // Start an async chain or an async script.

  }, {
    key: "_runAsync",
    value: function _runAsync(_ref, onEnd) {
      var _this14 = this;

      var to = _ref.to,
          props = _objectWithoutPropertiesLoose(_ref, ["to"]); // Merge other props immediately.


      if (this._diff(props)) {
        this._animate(props);
      } // Async scripts can be declaratively cancelled.


      if (props.cancel === true) {
        this.props.asyncTo = void 0;
        return onEnd(false);
      } // Never run more than one script at a time


      var timestamp = props.timestamp;

      if (!this._diff({
        asyncTo: to,
        timestamp: timestamp
      })) {
        return onEnd(false);
      }

      var isCancelled = function isCancelled() {
        return (// Cancelling methods touch the `cancelledAt` property
          timestamp < _this14.cancelledAt || // Async scripts are also cancelled when a new chain/script begins
          is.fun(to) && to !== _this14.props.asyncTo
        );
      };

      var last;

      var next = function next(props) {
        if (isCancelled()) throw _this14;
        return (last = new Promise(function (done) {
          _this14.update(props).start(done);
        })).then(function () {
          if (isCancelled()) throw _this14;
        });
      };

      var queue = Promise.resolve();

      if (is.arr(to)) {
        to.forEach(function (props) {
          return queue = queue.then(function () {
            return next(props);
          });
        });
      } else if (is.fun(to)) {
        queue = queue.then(function () {
          return to(next, _this14.stop.bind(_this14)) // Always wait for the last update.
          .then(function () {
            return last;
          });
        });
      }

      queue.catch(function (err) {
        return err !== _this14 && console.error(err);
      }).then(function () {
        return onEnd(!isCancelled());
      });
    } // Merge every fresh prop. Returns true if one or more props changed.
    // These props are ignored: (delay, config, immediate, reverse)

  }, {
    key: "_diff",
    value: function _diff(_ref2) {
      var _this15 = this;

      var timestamp = _ref2.timestamp,
          delay = _ref2.delay,
          config = _ref2.config,
          immediate = _ref2.immediate,
          reverse = _ref2.reverse,
          props = _objectWithoutPropertiesLoose(_ref2, ["timestamp", "delay", "config", "immediate", "reverse"]);

      var changed = false; // Ensure the newer timestamp is used.

      var diffTimestamp = function diffTimestamp(keyPath) {
        var previous = _this15.timestamps[keyPath];

        if (is.und(previous) || timestamp >= previous) {
          _this15.timestamps[keyPath] = timestamp;
          return true;
        }

        return false;
      }; // Generalized diffing algorithm


      var diffProp = function diffProp(keys, value, parent) {
        if (is.und(value)) return;
        var lastKey = keys[keys.length - 1];

        if (is.obj(value)) {
          if (!is.obj(parent[lastKey])) parent[lastKey] = {};

          for (var key in value) {
            diffProp(keys.concat(key), value[key], parent[lastKey]);
          }
        } else if (diffTimestamp(keys.join('.'))) {
          var oldValue = parent[lastKey];

          if (!isEqual(value, oldValue)) {
            changed = true;
            parent[lastKey] = value;
          }
        }
      };

      if (reverse) {
        var to = props.to;
        props.to = props.from;
        props.from = is.obj(to) ? to : void 0;
      }

      for (var key in props) {
        diffProp([key], props[key], this.props);
      } // These props only affect one update


      if ('reset' in props) this.props.reset = false;
      if ('cancel' in props) this.props.cancel = void 0;
      return changed;
    } // Return true if the given prop was changed by this update

  }, {
    key: "_isModified",
    value: function _isModified(props, prop) {
      return this.timestamps[prop] === props.timestamp;
    } // Update the animation configs. The given props override any default props.

  }, {
    key: "_animate",
    value: function _animate(props) {
      var _this16 = this;

      var _this$props = this.props,
          _this$props$from = _this$props.from,
          from = _this$props$from === void 0 ? emptyObj : _this$props$from,
          _this$props$to = _this$props.to,
          to = _this$props$to === void 0 ? emptyObj : _this$props$to,
          attach = _this$props.attach,
          onStart = _this$props.onStart;

      var isPrevented = function isPrevented(_) {
        return false;
      };

      if (props.cancel && this._isModified(props, 'cancel')) {
        // Stop all animations when `cancel` is true
        if (props.cancel === true) {
          this.stop(); // Prevent pending updates from *before* this update only!
          // (This must come after the `stop` call above)

          this.cancelledAt = props.timestamp;
          return this;
        } // Prevent matching properties from animating when
        // `cancel` is a string or array of strings


        var keys = toArray(props.cancel);

        if (is.arr(keys) && keys.length) {
          isPrevented = function isPrevented(key) {
            return keys.indexOf(key) >= 0;
          };

          this.stop.apply(this, _toConsumableArray(keys));
        }
      } // Merge `from` values with `to` values


      this.merged = freeze(_extends({}, from, to)); // True if any animation was updated

      var changed = false; // The animations that are starting or restarting

      var started = []; // Attachment handling, trailed springs can "attach" themselves to a previous spring

      var target = attach && attach(this); // Reduces input { key: value } pairs into animation objects

      for (var key in this.merged) {
        if (isPrevented(key)) continue;
        var state = this.animations[key];

        if (!state) {
          console.warn("Failed to animate key: \"".concat(key, "\"\n") + "Did you forget to define \"from.".concat(key, "\" for an async animation?"));
          continue;
        } // Reuse the Animated nodes whenever possible


        var animated = state.animated,
            animatedValues = state.animatedValues;
        var value = this.merged[key];
        var goalValue = computeGoalValue(value);
        var currValue = animated.getValue(); // Stop animations with a goal value equal to its current value.

        if (!props.reset && isEqual(goalValue, currValue)) {
          // The animation might be stopped already.
          if (!state.idle) {
            changed = true;

            this._stopAnimation(key);
          }

          continue;
        } // Replace an animation when its goal value is changed (or it's been reset)


        if (props.reset || !isEqual(goalValue, state.isNew ? currValue : state.goalValue)) {
          var _ret = function () {
            var _ref3 = is.und(props.immediate) ? _this16.props : props,
                immediate = _ref3.immediate;

            immediate = !!callProp(immediate, key);
            var isActive = animatedValues.some(function (v) {
              return !v.done;
            });
            var fromValue = !is.und(from[key]) ? computeGoalValue(from[key]) : goalValue; // Animatable strings use interpolation

            var isInterpolated = isAnimatableString(value);

            if (isInterpolated) {
              var output = [props.reset ? fromValue : animated.getValue(), goalValue];
              var input = animatedValues[0];

              if (input) {
                input.setValue(0, false);
                input.reset(isActive);
              } else {
                input = new AnimatedValue(0);
              }

              try {
                var prev = animated;
                animated = input.interpolate({
                  output: output
                });
                moveChildren(prev, animated);
              } catch (err) {
                console.warn('Failed to interpolate string from "%s" to "%s"', output[0], output[1]);
                console.error(err);
                return "continue";
              }

              if (immediate) {
                input.setValue(1, false);
              }
            } else {
              // Convert values into Animated nodes (reusing nodes whenever possible)
              if (is.arr(value)) {
                if (animated instanceof AnimatedValueArray) {
                  if (props.reset) animated.setValue(fromValue, false);
                  animatedValues.forEach(function (v) {
                    return v.reset(isActive);
                  });
                } else {
                  var _prev = animated;
                  animated = createAnimated(fromValue);
                  moveChildren(_prev, animated);
                }
              } else {
                if (animated instanceof AnimatedValue) {
                  if (props.reset) animated.setValue(fromValue, false);
                  animated.reset(isActive);
                } else {
                  var _prev2 = animated;
                  animated = new AnimatedValue(fromValue);
                  moveChildren(_prev2, animated);
                }
              }

              if (immediate) {
                animated.setValue(goalValue, false);
              }
            } // Only change the "config" of updated animations.


            var config = callProp(props.config, key) || callProp(_this16.props.config, key) || emptyObj;

            if (!immediate) {
              started.push(key);
            }

            changed = true;
            animatedValues = toArray(animated.getPayload());
            _this16.animations[key] = {
              key: key,
              idle: false,
              goalValue: goalValue,
              toValues: toArray(target instanceof Controller ? target.animations[key].animated.getPayload() : isInterpolated && 1 || goalValue),
              fromValues: animatedValues.map(function (v) {
                return v.getValue();
              }),
              animated: animated,
              animatedValues: animatedValues,
              immediate: immediate,
              duration: config.duration,
              easing: withDefault(config.easing, linear),
              decay: config.decay,
              mass: withDefault(config.mass, 1),
              tension: withDefault(config.tension, 170),
              friction: withDefault(config.friction, 26),
              initialVelocity: withDefault(config.velocity, 0),
              clamp: withDefault(config.clamp, false),
              precision: withDefault(config.precision, 0.005),
              config: config
            };
          }();

          if (_ret === "continue") continue;
        }
      }

      if (changed) {
        if (onStart && started.length) {
          started.forEach(function (key) {
            return onStart(_this16.animations[key]);
          });
        } // Make animations available to the frameloop


        var _keys2 = Object.keys(this.animations);

        this.configs.length = _keys2.length;

        _keys2.forEach(function (key, i) {
          var config = _this16.animations[key];
          _this16.configs[i] = config;
          _this16.values[key] = config.animated.getValue();
          _this16.animated[key] = config.animated;
        });
      }

      return this;
    }
    /**
     * Stop an animation by its key.
     *
     * This mutates the `timestamps.to[key]`, `props.to[key]`, and `animations[key]` properties.
     * Notably, it does *not* mutate the `configs[key]` or `animated[key]` properties.
     */

  }, {
    key: "_stopAnimation",
    value: function _stopAnimation(key, isNew) {
      var animated = this.animated[key];

      if (!animated) {
        return console.warn("Cannot stop an animation for a key that isn't animated: \"".concat(key, "\""));
      } // Prevent any pending updates to this key


      this.timestamps['to.' + key] = now(); // Idle animations are skipped unless their Animated node changed

      var state = this.animations[key] || emptyObj;
      if (state.idle && animated === state.animated) return; // Use the previous `isNew` value if nothing was passed

      if (is.und(isNew)) {
        isNew = !!state.isNew;
      } // Tell the frameloop to skip animating these values


      var animatedValues = toArray(animated.getPayload());
      animatedValues.forEach(function (v) {
        return v.done = true;
      }); // The current value becomes the goal value,
      // which ensures the integrity of the diffing algorithm.

      var goalValue = animated.getValue();

      if (this.props.to) {
        this.props.to[key] = goalValue;
      } // Remove unused data from this key's animation config


      this.animations[key] = {
        key: key,
        idle: true,
        isNew: isNew,
        goalValue: goalValue,
        animated: animated,
        animatedValues: animatedValues
      };
    }
  }]);

  return Controller;
}();
/** Wrap any value with an `Animated` node */


function createAnimated(value) {
  return is.arr(value) ? new AnimatedValueArray(value.map(function (value) {
    var animated = createAnimated(value);
    var payload = animated.getPayload();
    return animated instanceof AnimatedInterpolation ? payload[0] : payload;
  })) : isAnimatableString(value) ? // Convert "red" into "rgba(255, 0, 0, 1)" etc
  new AnimatedValue(0).interpolate({
    output: [value, value]
  }) : // The `AnimatedValue` class supports any type, but only numbers are
  // interpolated by the frameloop.
  new AnimatedValue(value);
}
/**
 * Replace an `Animated` node in the graph.
 * This is most useful for async updates, which don't cause a re-render.
 */


function moveChildren(prev, next) {
  var children = prev.getChildren().slice();
  children.forEach(function (child) {
    prev.removeChild(child);
    next.addChild(child); // Replace `prev` with `next` in child payloads

    var payload = child.getPayload();

    if (is.arr(payload)) {
      var i = payload.indexOf(prev);

      if (i >= 0) {
        var copy = _toConsumableArray(payload);

        copy[i] = next;
        child['payload'] = copy;
      }
    } else if (is.obj(payload)) {
      var entry = Object.entries(payload).find(function (entry) {
        return entry[1] === prev;
      });

      if (entry) {
        child['payload'] = _extends({}, payload, _defineProperty({}, entry[0], next));
      }
    }
  });
} // Merge updates with the same delay.
// NOTE: Mutation of `props` may occur!


function reduceDelays(merged, props) {
  var prev = merged[props.delay];

  if (prev) {
    props.to = merge(prev.to, props.to);
    props.from = merge(prev.from, props.from);
    Object.assign(prev, props);
  } else {
    merged[props.delay] = props;
  }

  return merged;
}

function merge(dest, src) {
  return is.obj(dest) && is.obj(src) ? _extends({}, dest, src) : src || dest;
} // Not all strings can be animated (eg: {display: "none"})


function isAnimatableString(value) {
  if (!is.str(value)) return false;
  return value.startsWith('#') || /\d/.test(value) || !!colorNames[value];
} // Compute the goal value, converting "red" to "rgba(255, 0, 0, 1)" in the process


function computeGoalValue(value) {
  return is.arr(value) ? value.map(computeGoalValue) : isAnimatableString(value) ? createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
} // Compare animatable values


function isEqual(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length) return false;

    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }

    return true;
  }

  return a === b;
}
/** API
 * const props = useSprings(number, [{ ... }, { ... }, ...])
 * const [props, set] = useSprings(number, (i, controller) => ({ ... }))
 */


var useSprings = function useSprings(length, propsArg, deps) {
  var hasNewSprings = length !== usePrev(length);
  var isFn = is.fun(propsArg);
  var state = useRef({
    springs: [],
    ref: null
  }).current; // The `propsArg` coerced into an array

  var props = isFn ? [] : propsArg; // Recreate the controllers whenever `length` changes

  var springs = useMemo(function () {
    return fillArray(length, function (i) {
      var s = new Controller();
      var p = props[i] || (props[i] = callProp(propsArg, i, s));
      return s.update(p);
    });
  }, [length]);

  var _useMemo = useMemo(function () {
    return {
      /** Apply any pending updates */
      start: function start() {
        return Promise.all(state.springs.map(function (s) {
          return new Promise(function (done) {
            return s.start(done);
          });
        }));
      },

      /** Update the spring controllers */
      update: function update(props) {
        var isFn = is.fun(props);
        var isArr = is.arr(props);
        state.springs.forEach(function (spring, i) {
          spring.update(isFn ? callProp(props, i, spring) : isArr ? props[i] : props);
          if (!state.ref) spring.start();
        });
      },

      /** Stop one key or all keys from animating */
      stop: function stop() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return state.springs.forEach(function (s) {
          return s.stop.apply(s, args);
        });
      }
    };
  }, []),
      start = _useMemo.start,
      update = _useMemo.update,
      stop = _useMemo.stop;

  var ref = props[0] ? props[0].ref : isFn ? state.ref : null;
  useImperativeHandle(ref, function () {
    return {
      start: start,
      stop: stop,

      get controllers() {
        return state.springs;
      }

    };
  }); // Once mounted, update the local state and start any animations.

  useEffect(function () {
    if (!isFn || hasNewSprings) {
      props.forEach(function (p, i) {
        // Set default props for async updates
        springs[i].setProp('config', p.config);
        springs[i].setProp('immediate', p.immediate);
      });
    }

    if (hasNewSprings) {
      state.springs.forEach(function (s) {
        return s.destroy();
      });
      state.springs = springs;
      state.ref = ref;

      if (!ref) {
        springs.forEach(function (s) {
          return s.start();
        });
      }
    } else if (!isFn) {
      update(props);
    }
  }, deps); // Destroy the controllers on unmount

  useEffect(function () {
    return function () {
      return state.springs.forEach(function (s) {
        return s.destroy();
      });
    };
  }, []);
  var values = springs.map(function (s) {
    return _extends({}, s.animated);
  });
  return isFn ? [values, update, stop] : values;
};
/** API
 * const props = useSpring({ ... })
 * const [props, set] = useSpring(() => ({ ... }))
 */


var useSpring = function useSpring(props, deps) {
  var isFn = is.fun(props);

  var _useSprings = useSprings(1, isFn ? props : [props], deps),
      result = _useSprings[0],
      set = _useSprings[1],
      stop = _useSprings[2];

  return isFn ? [result[0], set, stop] : result;
};
/** API
 * const trails = useTrail(number, { ... })
 * const [trails, set] = useTrail(number, () => ({ ... }))
 */


var useTrail = function useTrail(length, propsArg) {
  var hasNewSprings = length !== usePrev(length);
  var isFn = is.fun(propsArg); // The `propsArg` coerced into an object

  var props = isFn ? null : propsArg; // Retain the controllers so we can update them.

  var springsRef = useRef([]);
  var springs = springsRef.current;
  if (hasNewSprings) springs.length = length; // The controllers are recreated whenever `length` changes.

  var _useSprings = useSprings(length, function (i, spring) {
    if (isFn && !props) props = callProp(propsArg) || {};
    springs[i] = spring;
    return _extends({}, props, {
      config: callProp(props.config, i),
      attach: i > 0 && function () {
        return springs[i - 1];
      }
    });
  }),
      values = _useSprings[0],
      animate = _useSprings[1],
      stop = _useSprings[2];
  /** For imperative updates to the props of all springs in the trail */


  var update = useCallback(function (propsArg) {
    return animate(function (i, spring) {
      var props = callProp(propsArg, i, spring) || {};
      var parent = springsRef.current[props.reverse ? i + 1 : i - 1];
      return _extends({}, props, {
        config: callProp(props.config, i),
        attach: !!parent && function () {
          return parent;
        }
      });
    });
  }, []); // Update the animations on re-render when `propsArg` is an object
  // and the controllers were *not* created in the current render.

  useEffect(function () {
    if (!isFn && !hasNewSprings) {
      update(propsArg);
    }
  }); // Return the update/stop functions when the `propsArg` is a function.

  return isFn ? [values, update, stop] : values;
};
/** API
 * const transitions = useTransition(items, itemKeys, { ... })
 * const [transitions, update] = useTransition(items, itemKeys, () => ({ ... }))
 */


var guid = 0;
var INITIAL = 'initial';
var ENTER = 'enter';
var UPDATE = 'update';
var LEAVE = 'leave';

var makeKeys = function makeKeys(items, keys) {
  return (typeof keys === 'function' ? items.map(keys) : toArray(keys)).map(String);
};

var makeConfig = function makeConfig(props) {
  var items = props.items,
      keys = props.keys,
      rest = _objectWithoutPropertiesLoose(props, ["items", "keys"]);

  items = toArray(is.und(items) ? null : items);
  return _extends({
    items: items,
    keys: makeKeys(items, keys)
  }, rest);
};

function useTransition(input, keyTransform, props) {
  props = makeConfig(_extends({}, props, {
    items: input,
    keys: keyTransform || function (i) {
      return i;
    }
  }));

  var _props = props,
      _props$lazy = _props.lazy,
      lazy = _props$lazy === void 0 ? false : _props$lazy,
      _props$unique = _props.unique,
      from = _props.from,
      enter = _props.enter,
      leave = _props.leave,
      update = _props.update,
      onDestroyed = _props.onDestroyed,
      keys = _props.keys,
      items = _props.items,
      onFrame = _props.onFrame,
      _onRest = _props.onRest,
      onStart = _props.onStart,
      ref = _props.ref,
      extra = _objectWithoutPropertiesLoose(_props, ["lazy", "unique", "from", "enter", "leave", "update", "onDestroyed", "keys", "items", "onFrame", "onRest", "onStart", "ref"]);

  var forceUpdate = useForceUpdate();
  var mounted = useRef(false);
  var state = useRef({
    mounted: false,
    first: true,
    deleted: [],
    current: {},
    transitions: [],
    prevProps: {},
    paused: !!props.ref,
    instances: !mounted.current && new Map(),
    forceUpdate: forceUpdate
  });
  useImperativeHandle(props.ref, function () {
    return {
      start: function start() {
        return Promise.all(Array.from(state.current.instances).map(function (_ref) {
          var c = _ref[1];
          return new Promise(function (r) {
            return c.start(r);
          });
        }));
      },
      stop: function stop(finished) {
        return Array.from(state.current.instances).forEach(function (_ref2) {
          var c = _ref2[1];
          return c.stop(finished);
        });
      },

      get controllers() {
        return Array.from(state.current.instances).map(function (_ref3) {
          var c = _ref3[1];
          return c;
        });
      }

    };
  }); // Update state

  state.current = diffItems(state.current, props);

  if (state.current.changed) {
    // Update state
    state.current.transitions.forEach(function (transition) {
      var phase = transition.phase,
          key = transition.key,
          item = transition.item,
          props = transition.props;
      if (!state.current.instances.has(key)) state.current.instances.set(key, new Controller()); // Avoid calling `onStart` more than once per transition.

      var started = false; // update the map object

      var ctrl = state.current.instances.get(key);

      var itemProps = _extends({}, extra, props, {
        ref: ref,
        onRest: function onRest(values) {
          if (state.current.mounted) {
            if (transition.destroyed) {
              // If no ref is given delete destroyed items immediately
              if (!ref && !lazy) cleanUp(state, key);
              if (onDestroyed) onDestroyed(item);
            } // A transition comes to rest once all its springs conclude


            var curInstances = Array.from(state.current.instances);

            var _active = curInstances.some(function (_ref4) {
              var c = _ref4[1];
              return !c.idle;
            });

            if (!_active && (ref || lazy) && state.current.deleted.length > 0) {
              cleanUp(state);
            }

            if (_onRest) {
              _onRest(item, phase, values);
            }
          }
        },
        onFrame: onFrame && function (values) {
          return onFrame(item, phase, values);
        },
        onStart: onStart && function (animation) {
          return started || (started = (onStart(item, phase, animation), true));
        } // Update controller

      });

      ctrl.update(itemProps);
      if (!state.current.paused) ctrl.start();
    });
  }

  useEffect(function () {
    state.current.mounted = mounted.current = true;
    return function () {
      state.current.mounted = mounted.current = false;
      Array.from(state.current.instances).map(function (_ref5) {
        var c = _ref5[1];
        return c.destroy();
      });
      state.current.instances.clear();
    };
  }, []);
  return state.current.transitions.map(function (_ref6) {
    var item = _ref6.item,
        phase = _ref6.phase,
        key = _ref6.key;
    return {
      item: item,
      key: key,
      phase: phase,
      props: state.current.instances.get(key).animated
    };
  });
}

function cleanUp(_ref7, filterKey) {
  var state = _ref7.current;
  var deleted = state.deleted;

  var _iterator3 = _createForOfIteratorHelper(deleted),
      _step3;

  try {
    var _loop2 = function _loop2() {
      var _ref8 = _step3.value;
      var key = _ref8.key;

      var filter = function filter(t) {
        return t.key !== key;
      };

      if (is.und(filterKey) || filterKey === key) {
        state.instances.delete(key);
        state.transitions = state.transitions.filter(filter);
        state.deleted = state.deleted.filter(filter);
      }
    };

    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  state.forceUpdate();
}

function diffItems(_ref9, props) {
  var first = _ref9.first,
      current = _ref9.current,
      deleted = _ref9.deleted,
      prevProps = _ref9.prevProps,
      state = _objectWithoutPropertiesLoose(_ref9, ["first", "current", "deleted", "prevProps"]);

  var items = props.items,
      keys = props.keys,
      initial = props.initial,
      from = props.from,
      enter = props.enter,
      leave = props.leave,
      update = props.update,
      _props$trail = props.trail,
      trail = _props$trail === void 0 ? 0 : _props$trail,
      unique = props.unique,
      config = props.config,
      _props$order = props.order,
      order = _props$order === void 0 ? [ENTER, LEAVE, UPDATE] : _props$order;

  var _makeConfig = makeConfig(prevProps),
      _keys = _makeConfig.keys,
      _items = _makeConfig.items;

  if (props.reset) {
    current = {};
    state.transitions = [];
  } // Compare next keys with current keys


  var currentKeys = Object.keys(current);
  var currentSet = new Set(currentKeys);
  var nextSet = new Set(keys);
  var addedKeys = keys.filter(function (key) {
    return !currentSet.has(key);
  });
  var updatedKeys = update ? keys.filter(function (key) {
    return currentSet.has(key);
  }) : [];
  var deletedKeys = state.transitions.filter(function (t) {
    return !t.destroyed && !nextSet.has(t.originalKey);
  }).map(function (t) {
    return t.originalKey;
  });
  var delay = -trail;

  var _loop3 = function _loop3() {
    var phase = order.shift();

    if (phase === ENTER) {
      if (first && !is.und(initial)) {
        phase = INITIAL;
        from = initial;
      }

      addedKeys.forEach(function (key) {
        // In unique mode, remove fading out transitions if their key comes in again
        if (unique && deleted.find(function (d) {
          return d.originalKey === key;
        })) {
          deleted = deleted.filter(function (t) {
            return t.originalKey !== key;
          });
        }

        var i = keys.indexOf(key);
        var item = items[i];
        var enterProps = callProp(enter, item, i);
        current[key] = {
          phase: phase,
          originalKey: key,
          key: unique ? String(key) : guid++,
          item: item,
          props: _extends({
            delay: delay += trail,
            config: callProp(config, item, phase),
            from: callProp(from, item),
            to: enterProps
          }, is.obj(enterProps) && interpolateTo(enterProps))
        };
      });
    } else if (phase === LEAVE) {
      deletedKeys.forEach(function (key) {
        var i = _keys.indexOf(key);

        var item = _items[i];
        var leaveProps = callProp(leave, item, i);
        deleted.push(_extends({}, current[key], {
          phase: phase,
          destroyed: true,
          left: _keys[i - 1],
          right: _keys[i + 1],
          props: _extends({
            delay: delay += trail,
            config: callProp(config, item, phase),
            to: leaveProps
          }, is.obj(leaveProps) && interpolateTo(leaveProps))
        }));
        delete current[key];
      });
    } else if (phase === UPDATE) {
      updatedKeys.forEach(function (key) {
        var i = keys.indexOf(key);
        var item = items[i];
        var updateProps = callProp(update, item, i);
        current[key] = _extends({}, current[key], {
          phase: phase,
          props: _extends({
            delay: delay += trail,
            config: callProp(config, item, phase),
            to: updateProps
          }, is.obj(updateProps) && interpolateTo(updateProps))
        });
      });
    }
  };

  while (order.length) {
    _loop3();
  }

  var out = keys.map(function (key) {
    return current[key];
  });
  out = reconcileDeleted(deleted, out);
  return _extends({}, state, {
    first: first && !addedKeys.length,
    changed: !!(addedKeys.length || deletedKeys.length || updatedKeys.length),
    transitions: out,
    current: current,
    deleted: deleted,
    prevProps: props
  });
} // The `mass` prop defaults to 1


var config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};

function Spring(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return children(useSpring(props));
}

function Trail(_ref2) {
  var items = _ref2.items,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, ["items", "children"]);

  var trails = useTrail(items.length, props);
  return items.map(function (item, index) {
    var result = children(item, index);
    return is.fun(result) ? result(trails[index]) : result;
  });
}

function Transition(_ref3) {
  var items = _ref3.items,
      _ref3$keys = _ref3.keys,
      keys = _ref3$keys === void 0 ? null : _ref3$keys,
      children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, ["items", "keys", "children"]);

  var transitions = useTransition(items, keys, props);
  return transitions.map(function (_ref4, index) {
    var item = _ref4.item,
        key = _ref4.key,
        props = _ref4.props,
        phase = _ref4.phase;
    var result = children(item, phase, index);
    var element = is.fun(result) ? result(props) : result;
    return element && React.createElement(element.type, _extends({
      key: key
    }, element.props));
  });
}

assign({
  createAnimatedStyle: function createAnimatedStyle(style) {
    return new AnimatedStyle(style);
  },
  createAnimatedInterpolation: function createAnimatedInterpolation$$1(parents) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return new AnimatedInterpolation(parents, args);
  }
});
/**
 * Wraps the `style` property with `AnimatedStyle`.
 */

var AnimatedProps = /*#__PURE__*/function (_AnimatedObject2) {
  _inherits(AnimatedProps, _AnimatedObject2);

  var _super7 = _createSuper(AnimatedProps);

  function AnimatedProps(props, callback) {
    var _this17;

    _classCallCheck(this, AnimatedProps);

    _this17 = _super7.call(this, props.style && createAnimatedStyle ? _extends({}, props, {
      style: createAnimatedStyle(props.style)
    }) : props);
    _this17.update = void 0;
    _this17.update = callback;

    _this17.attach();

    return _this17;
  }

  return _createClass(AnimatedProps);
}(AnimatedObject);

var createAnimatedComponent = function createAnimatedComponent(Component) {
  var AnimatedComponent = forwardRef(function (props, _ref) {
    var forceUpdate = useForceUpdate();
    var mounted = useRef(true);
    var propsAnimated = useRef(null);
    var node = useRef(null);
    var attachProps = useCallback(function (props) {
      var oldPropsAnimated = propsAnimated.current;

      var callback = function callback() {
        if (node.current) {
          var didUpdate = applyAnimatedValues(node.current, propsAnimated.current.getAnimatedValue());
          if (didUpdate === false) forceUpdate();
        }
      };

      propsAnimated.current = new AnimatedProps(props, callback);
      oldPropsAnimated && oldPropsAnimated.detach();
    }, []);
    useEffect(function () {
      return function () {
        mounted.current = false;
        propsAnimated.current && propsAnimated.current.detach();
      };
    }, []);
    useImperativeHandle(_ref, function () {
      return createAnimatedRef(node, mounted, forceUpdate);
    });
    attachProps(props);

    var _getValue = propsAnimated.current.getValue(),
        scrollTop = _getValue.scrollTop,
        scrollLeft = _getValue.scrollLeft,
        animatedProps = _objectWithoutPropertiesLoose(_getValue, ["scrollTop", "scrollLeft"]);

    return React.createElement(Component, _extends({}, animatedProps, {
      ref: function ref(childRef) {
        return node.current = handleRef(childRef, _ref);
      }
    }));
  });
  return AnimatedComponent;
}; // withExtend(animated, options = {})
//

/** Add an `extend` method to your `animated` factory function */


function withExtend(animated, options) {
  if (options === void 0) {
    options = {};
  }

  var self = animated;

  self.extend = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    args.forEach(function (arg) {
      return extend(arg);
    });
    return self;
  };

  return self;

  function extend(arg, overrideKey) {
    // Arrays avoid passing their index to `extend`
    if (is.arr(arg)) {
      return arg.forEach(function (arg) {
        return extend(arg);
      });
    } // Object keys are always used over value inspection


    if (is.obj(arg)) {
      for (var _key2 in arg) {
        extend(arg[_key2], _key2);
      }

      return;
    } // Use the `overrideKey` or inspect the value for a key


    var key = is.str(overrideKey) ? overrideKey : is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) ? arg.name : ''; // This lowercases the first letter of the key

    if (options.lowercase) {
      key = key[0].toLowerCase() + key.slice(1);
    } // NOTE(typescript): Properties are not yet inferred from the arguments of
    // the `extend` method and then attached to the `animated` function via
    // the return type.


    self[key] = animated(arg);
  }
}

var elements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan']; // Extend `animated` with every available DOM element

var animated$1 = withExtend(createAnimatedComponent).extend(elements);
/** @deprecated Use `animated.extend` instead */

var apply = animated$1.extend;
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

var prefixKey = function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
};

var prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce(function (acc, prop) {
  prefixes.forEach(function (prefix) {
    return acc[prefixKey(prefix, prop)] = acc[prop];
  });
  return acc;
}, isUnitlessNumber);

function dangerousStyleValue(name, value, isCustomProperty) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers

  return ('' + value).trim();
}

var attributeCache = {};

function applyAnimatedValues$1(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }

  var _ref = props,
      style = _ref.style,
      children = _ref.children,
      scrollTop = _ref.scrollTop,
      scrollLeft = _ref.scrollLeft,
      attributes = _objectWithoutPropertiesLoose(_ref, ["style", "children", "scrollTop", "scrollLeft"]);

  if (scrollTop !== void 0) instance.scrollTop = scrollTop;
  if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft; // Set textContent, if children is an animatable value

  if (children !== void 0) instance.textContent = children; // Apply CSS styles

  for (var styleName in style) {
    if (!style.hasOwnProperty(styleName)) continue;
    var isCustomProperty = styleName.indexOf('--') === 0;
    var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
    if (styleName === 'float') styleName = 'cssFloat';
    if (isCustomProperty) instance.style.setProperty(styleName, styleValue);else instance.style[styleName] = styleValue;
  }

  var isFilterElement = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter'; // Apply DOM attributes

  for (var name in attributes) {
    // Attributes are written in dash case
    var attributeName = isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, function (n) {
      return '-' + n.toLowerCase();
    }));
    instance.setAttribute(attributeName, attributes[name]);
  }
} // const INTEGER = '[-+]?\\d+';


var NUMBER = '[-+]?\\d*\\.?\\d+';
var PERCENTAGE = NUMBER + '%';

function call() {
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}

var rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/; // http://www.w3.org/TR/css3-color/#svg-color

var colors = {
  transparent: 0x00000000,
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
};
/*
https://github.com/react-community/normalize-css-color

BSD 3-Clause License

Copyright (c) 2016, React Community
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of the copyright holder nor the names of its
  contributors may be used to endorse or promote products derived from
  this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

function normalizeColor(color) {
  var match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  } // Ordered based on occurrences on Facebook codebase


  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
  if (colors.hasOwnProperty(color)) return colors[color];

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    0x000000ff) >>> // a
    0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    'ff', // a
    16) >>> 0;
  } // https://drafts.csswg.org/css-color-4/#hex-notation


  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | 0x000000ff) >>> // a
    0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | parse1(match[4])) >>> // a
    0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p = 2 * l - q;
  var r = hue2rgb(p, q, h + 1 / 3);
  var g = hue2rgb(p, q, h);
  var b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  var int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  var int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  var num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  var int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  var int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  var r = (int32Color & 0xff000000) >>> 24;
  var g = (int32Color & 0x00ff0000) >>> 16;
  var b = (int32Color & 0x0000ff00) >>> 8;
  var a = (int32Color & 0x000000ff) / 255;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
} // Problem: https://github.com/animatedjs/animated/pull/102
// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662


var stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g; // Covers rgb, rgba, hsl, hsla
// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e

var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi; // Covers color names (transparent, blue, etc.)

var colorNamesRegex = new RegExp("(".concat(Object.keys(colors).join('|'), ")"), 'g');
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36)           // colors
 *   -45deg                            // values with units
 *   0 2px 2px 0px rgba(0, 0, 0, 0.12) // box shadows
 */

var createStringInterpolator$1 = function createStringInterpolator$1(config) {
  // Replace colors with rgba
  var outputRange = config.output.map(function (rangeValue) {
    return rangeValue.replace(colorRegex, colorToRgba);
  }).map(function (rangeValue) {
    return rangeValue.replace(colorNamesRegex, colorToRgba);
  });
  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
    return [];
  });
  outputRange.forEach(function (value) {
    value.match(stringShapeRegex).forEach(function (number, i) {
      return outputRanges[i].push(+number);
    });
  });
  var interpolations = outputRange[0].match(stringShapeRegex).map(function (_value, i) {
    return createInterpolator(_extends({}, config, {
      output: outputRanges[i]
    }));
  });
  return function (input) {
    var i = 0;
    return outputRange[0] // 'rgba(0, 100, 200, 0)'
    // ->
    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
    .replace(stringShapeRegex, function () {
      return interpolations[i++](input);
    }) // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
    // round the opacity (4th column).
    .replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, function (_, p1, p2, p3, p4) {
      return "rgba(".concat(Math.round(p1), ", ").concat(Math.round(p2), ", ").concat(Math.round(p3), ", ").concat(p4, ")");
    });
  };
};

assign({
  defaultElement: 'div',
  colorNames: colors,
  applyAnimatedValues: applyAnimatedValues$1,
  createStringInterpolator: createStringInterpolator$1
});
export { useChain, useSpring, useSprings, useTrail, useTransition, config, createAnimatedInterpolation as interpolate, Controller, Spring, Trail, Transition, animated$1 as animated, animated$1 as a, apply, Globals };